
export interface ICompanyGroupForPermissionListItem {
    id: string;
    code: string;
    name: string;
    comment: string;
    logo: string;
}

export class CompanyGroupForPermissionListItem implements ICompanyGroupForPermissionListItem {
    id: string;
    code: string;
    name: string;
    comment: string;
    logo: string;

    constructor();
    constructor(obj: ICompanyGroupForPermissionListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.comment = obj && obj.comment || "";
        this.logo = obj && obj.logo || "";
    }

    static createCompanyGroupForPermissionListItem(id: string, code: string, name: string): ICompanyGroupForPermissionListItem {
        const result = new CompanyGroupForPermissionListItem();
        result.id = id;
        result.code = code;
        result.name = name;
        return result;
    }
}